import { ActionReducer, createReducer, on } from '@ngrx/store';

import {
  addObjectGroup,
  deleteObjectGroups,
  loadObjectGroups,
  loadObjectGroupsFailure,
  loadObjectGroupsSuccess,
  updateObjectGroups,
} from '@store/actions/object-groups.actions';
import {
  initialObjectGroupsState,
  objectGroupsAdapter,
  ObjectGroupsState,
} from '@store/state/object-groups.state';

export const objectGroupsReducer: ActionReducer<ObjectGroupsState> = createReducer(
  initialObjectGroupsState,
  // загрузка
  on(loadObjectGroups, (state) => ({
    ...state,
    loading: true,
    error: undefined,
  })),

  on(loadObjectGroupsSuccess, (state, { list }) =>
    objectGroupsAdapter.setAll(list, {
      ...state,
      loading: false,
    }),
  ),

  on(loadObjectGroupsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(addObjectGroup, (state, { group }) => objectGroupsAdapter.addOne(group, state)),
  on(updateObjectGroups, (state, { id, changes }) =>
    objectGroupsAdapter.updateOne({ id: +id, changes }, state),
  ),
  on(deleteObjectGroups, (state, { id }) => objectGroupsAdapter.removeOne(+id, state)),
);
